import { onBeforeUpdate as _onBeforeUpdate7 } from "gyron";
import { onBeforeUpdate as _onBeforeUpdate6 } from "gyron";
import { onBeforeUpdate as _onBeforeUpdate5 } from "gyron";
import { onBeforeUpdate as _onBeforeUpdate4 } from "gyron";
import { onBeforeUpdate as _onBeforeUpdate3 } from "gyron";
import { onBeforeUpdate as _onBeforeUpdate2 } from "gyron";
import { onBeforeUpdate as _onBeforeUpdate } from "gyron";
import { h as _h } from "gyron";
import { storeState } from '@/store';
import { createRef, FC, isVNode, nextRender, onAfterMount, useReactive } from 'gyron';
import { omit } from '@gyron/shared';
import { Link } from '@gyron/router';
import { AnchorIcon, CopyIcon } from './icons';
import { EVENT_TYPES, useEvent } from '@/hooks/event';
import classnames from 'classnames';
import { isDarkTheme } from './dark';
export const A = FC(({
  href,
  children
}) => {
  // Auxiliary update of deconstructed props
  _onBeforeUpdate((_, props) => {
    var _props = props;
    href = _props.href;
    children = _props.children;
  })
  if (/(\/\/|@)/.test(href)) {
    return ({
      href,
      children
    }) => _h("a", {
      "href": href,
      "target": "_blank"
    }, children);
  }
  if (/#/.test(href)) {
    return ({
      href,
      children
    }) => _h("a", {
      "href": href
    }, children);
  }
  return ({
    href,
    children
  }) => _h(Link, {
    "to": href
  }, children);
});
export const P = FC(({
  children
}) => {
  // Auxiliary update of deconstructed props
  _onBeforeUpdate((_, props) => {
    var _props2 = props;
    children = _props2.children;
  })
  return ({
    children
  }) => _h("p", {
    "itemProp": "description"
  }, children);
});
export const H1 = FC(({
  children
}) => {
  // Auxiliary update of deconstructed props
  _onBeforeUpdate((_, props) => {
    var _props3 = props;
    children = _props3.children;
  })
  return ({
    children
  }) => _h("h1", {
    "class": "inline-block text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight dark:text-slate-200",
    "itemProp": "headline name"
  }, children);
});
export const H2 = FC(({
  children
}) => {
  // Auxiliary update of deconstructed props
  _onBeforeUpdate((_, props) => {
    var _props4 = props;
    children = _props4.children;
  })
  const ref = createRef();
  onAfterMount(() => {
    nextRender(() => {
      if (ref.current) {
        const {
          id,
          offsetTop
        } = ref.current;
        storeState.guidance[offsetTop] = id;
      }
    });
  });
  return () => {
    let name = children[0];
    if (isVNode(name)) {
      name = name.children[0];
    }
    return _h("h2", {
      "itemProp": "headline name",
      "class": "group flex items-center whitespace-pre-wrap -ml-4 pl-4 relative guidance",
      "id": name,
      "ref": ref
    }, [_h("a", {
      "href": `#${name}`,
      "class": "absolute -ml-10 flex items-center opacity-0 border-0 group-hover:opacity-100"
    }, _h("div", {
      "class": "cursor-pointer w-6 h-6 text-slate-400 ring-1 ring-slate-900/5 rounded-md shadow-sm flex items-center justify-center hover:ring-slate-900/10 hover:shadow hover:text-slate-700 dark:bg-slate-700 dark:text-slate-300 dark:shadow-none dark:ring-0"
    }, _h(AnchorIcon, {}, []))), _h("span", {}, children)]);
  };
});
export const H3 = FC(({
  children
}) => {
  // Auxiliary update of deconstructed props
  _onBeforeUpdate((_, props) => {
    var _props5 = props;
    children = _props5.children;
  })
  const ref = createRef();
  onAfterMount(() => {
    nextRender(() => {
      if (ref.current) {
        const {
          id,
          offsetTop
        } = ref.current;
        storeState.guidance[offsetTop] = id;
      }
    });
  });
  return () => {
    let name = children[0];
    if (isVNode(name)) {
      name = name.children[0];
    }
    return _h("h3", {
      "class": "group flex items-center whitespace-pre-wrap -ml-4 pl-4 relative guidance",
      "id": name,
      "ref": ref
    }, [_h("a", {
      "href": `#${name}`,
      "class": "absolute -ml-10 flex items-center opacity-0 border-0 group-hover:opacity-100"
    }, _h("div", {
      "class": "cursor-pointer w-6 h-6 text-slate-400 ring-1 ring-slate-900/5 rounded-md shadow-sm flex items-center justify-center hover:ring-slate-900/10 hover:shadow hover:text-slate-700 dark:bg-slate-700 dark:text-slate-300 dark:shadow-none dark:ring-0"
    }, _h(AnchorIcon, {}, []))), _h("span", {}, children)]);
  };
});
const Pre = FC(({
  children,
  isSSR
}) => {
  // Auxiliary update of deconstructed props
  _onBeforeUpdate((_, props) => {
    var _props6 = props;
    children = _props6.children;
    isSSR = _props6.isSSR;
  })
  const code = children[0];
  let meta = code.props?.meta,
    timer = null;
  if (meta) {
    meta = JSON.parse(meta);
    code.props = omit(code.props, 'meta');
  }
  const copyState = useReactive({
    status: true,
    copying: false,
    mouse: false,
    isDark: isDarkTheme(isSSR)
  });
  const event = useEvent(EVENT_TYPES.dark, isDark => {
    copyState.isDark = isDark;
  });
  const copy = async () => {
    const content = meta?.content;
    try {
      copyState.copying = true;
      if (content) {
        await navigator.clipboard.writeText(content);
        copyState.status = true;
      } else {
        copyState.status = false;
      }
    } catch (e) {
      copyState.status = false;
    } finally {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        copyState.copying = false;
        timer = null;
      }, 2000);
    }
  };
  return ({
    children,
    isSSR
  }) => _h("div", {
    "class": classnames('relative group shadow-lg dark:shadow-lg-dark rounded-lg', {
      'mt-12': Boolean(meta?.filename)
    })
  }, [meta && meta.filename && _h("span", {
    "class": "absolute -top-[24px] bg-white dark:bg-[#00000080] text-slate-900 dark:text-white text-xs px-2 pb-2 pt-1 rounded rounded-bl-none"
  }, meta.filename), _h("div", {
    "aria-label": "Copy",
    "class": classnames('w-4 h-4 text-slate-600 dark:text-slate-100 absolute right-5 top-4 cursor-pointer opacity-20 group-hover:opacity-100 transition-opacity select-none'),
    "onClick": copy,
    "onMouseleave": () => copyState.copying = false,
    "onMousedown": () => copyState.mouse = true,
    "onMouseup": () => copyState.mouse = false
  }, [_h(CopyIcon, {
    "class": classnames({
      'translate-y-[1px] translate-x-[1px]': copyState.mouse
    })
  }, []), _h("div", {
    "class": classnames('opacity-0 bg-neutral-800 text-neutral-100 w-16 text-xs p-1 text-center left-1/2 -translate-x-1/2 absolute mt-2 rounded', {
      'opacity-100': copyState.copying
    })
  }, copyState.copying ? copyState.status ? '拷贝成功' : '拷贝失败' : '')]), _h("pre", {
    "class": classnames('bg-white dark:bg-[#1e293b] text-slate-800 dark:text-slate-100', {
      'prism-light': !copyState.isDark
    })
  }, code)]);
});
const Image = FC(({
  alt,
  src
}) => {
  // Auxiliary update of deconstructed props
  _onBeforeUpdate((_, props) => {
    var _props7 = props;
    alt = _props7.alt;
    src = _props7.src;
  })
  return ({
    alt,
    src
  }) => _h("img", {
    "src": src,
    "alt": alt
  }, []);
});
export const MdxHelper = {
  a: A,
  p: P,
  h1: H1,
  h2: H2,
  h3: H3,
  pre: Pre,
  img: Image
};